import { getHeaders, apiCall } from "services/api"

export const getFilters = ({ lang, env }) => {
  const headers = getHeaders(lang)

  const url = `${env.consumer_api_base}/${process.env.REACT_APP_API_FILTERS}`

  const request = new Request(url, {
    method: "GET",
    credentials: "omit",
    headers,
  })

  return apiCall(request)
}
